<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-container fluid>
          <template v-for="(item, index) in value">
            <v-flex xs12 class="text-center" :key="index">
              <h4 class="mb-2">
                {{item.title}}
              </h4>
            </v-flex>
            <v-layout row wrap class="mb-4" :key="index+'1'">
              <v-flex xs12 class="text-center radios" justify-center>
                <p-radio class="p-icon p-curve p-plain p-tada" :name="'boolean_'+id+'_'+index" :value="1" color="success-o" :checked="item.value == 1" v-on:change="radioChanged" v-model="item.value">
                  <i slot="extra" class="icon mdi mdi-chevron-down-circle-outline"></i>
                  JA
                </p-radio>

                <p-radio class="p-icon p-curve p-plain p-tada" :name="'boolean_'+id+'_'+index" :value="0" color="danger-o" :checked="!item.value == 1" v-on:change="radioChanged" v-model="item.value">
                  <i slot="extra" class="icon mdi mdi-alpha-x-circle-outline"></i>
                  NEI
                </p-radio>

                <p-radio v-if="notSure" class="p-icon p-curve p-plain p-tada" :name="'boolean_'+id+'_'+index" :value="2" color="warning-o" :checked="!item.value == 2" v-on:change="radioChanged" v-model="item.value">
                  <i slot="extra" class="icon mdi mdi-alpha-x-circle-outline"></i>
                  Uavklart
                </p-radio>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
  export default {
    props: ['value', 'relatedVmodel', 'notSure'],
    data() {
      return {
        id: null
      }
    }, 
    mounted () {
      this.id = this._uid
      
      this.$nextTick(function () {    
        if(this.value) {
          this.loadItems()
        }
      })
      
    },
    methods: {
      radioChanged: function(event) {
        this.$emit('update-fields');
      },
      loadItems() {
        for(let item in this.value) {
          if(this.relatedVmodel != null && this.relatedVmodel != undefined) {
            for(let relatedItem in this.relatedVmodel) {
              if(relatedItem == item) {
                if(!this.value[item].loadedFromRelated) {
                  this.value[item].value = this.relatedVmodel[relatedItem].value
                  this.value[item].loadedFromRelated = true
                }
              }
            }
          }
        }
      }
    },
    computed: {
      items: {
        get() {
          let items = []
          for(let item in this.value) {
            let tempItem = this.value[item]
            if(this.relatedVmodel != null && this.relatedVmodel != undefined) {
              for(let relatedItem in this.relatedVmodel) {
                if(relatedItem == item) {
                  tempItem.value = this.relatedVmodel[relatedItem].value
                  tempItem.loadedFromRelated = true
                }
              }
            }
            items.push(tempItem)
          }          
          return items
        }
      }
    }
  }
</script>

<style>
  .radios {
    font-size: 22px;
  }
</style>